var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 22H4.33398C3.80355 22 3.29484 21.7893 2.91977 21.4142C2.5447 21.0391 2.33398 20.5304 2.33398 20V13C2.33398 12.4696 2.5447 11.9609 2.91977 11.5858C3.29484 11.2107 3.80355 11 4.33398 11H7.33398M14.334 9V5C14.334 4.20435 14.0179 3.44129 13.4553 2.87868C12.8927 2.31607 12.1296 2 11.334 2L7.33398 11V22H18.614C19.0963 22.0055 19.5644 21.8364 19.9319 21.524C20.2994 21.2116 20.5417 20.7769 20.614 20.3L21.994 11.3C22.0375 11.0134 22.0182 10.7207 21.9373 10.4423C21.8565 10.1638 21.7161 9.90629 21.5258 9.68751C21.3356 9.46873 21.1001 9.29393 20.8356 9.17522C20.571 9.0565 20.2839 8.99672 19.994 9H14.334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.66b30ca880e795e40b42c67743c8bbc2.svg";
export { ForwardRef as ReactComponent };